import styled from "styled-components";

export const Map = styled.div``;
